export const DomainName = 'https://h5.sparknt.cn'
export const ApiBasePath = `${DomainName}/loanassist`

export const getApiBasePath = () => {
  const DomainName = localStorage.getItem('DomainName')
  return `${DomainName}/loanassist`
}

export const CityArray = {
  11: '北京',
  12: '天津',
  13: '河北',
  14: '山西',
  15: '内蒙古',
  21: '辽宁',
  22: '吉林',
  23: '黑龙江',
  31: '上海',
  32: '江苏',
  33: '浙江',
  34: '安徽',
  35: '福建',
  36: '江西',
  37: '山东',
  41: '河南',
  42: '湖北',
  43: '湖南',
  44: '广东',
  45: '广西',
  46: '海南',
  50: '重庆',
  51: '四川',
  52: '贵州',
  53: '云南',
  54: '西藏',
  61: '陕西',
  62: '甘肃',
  63: '青海',
  64: '宁夏',
  65: '新疆',
  71: '台湾',
  81: '香港',
  82: '澳门',
  91: '国外'
}

export const StatusMap = {
  'new': '新名单',
  'wait-visit': '待上门',
  'visited': '已上门',
  'has-agent': '已分配',
  'suspend': '面谈终止',
  'no-scheme': '无方案',
  'has-scheme': '有方案',
  'reviewing': '审批中',
  'rejected': '拒绝',
  'approved': '通过',
  'issued': '已放款',
  'commission': '已回款',
  'has-done': '已完结',
  'closed': '已关闭'
}

export const RoleCodeNameMap = {
  C: '坐席',
  L1: '电销主管',
  F: '前台',
  BIZ_FRONT: '公共前台',
  V: '接待',
  VL: '接待主管',
  BIZ_VISIT: '公共接待',
  BIZ_VISIT_L: '公共接待主管',
  NM: '名单管理员',
  HR: '人事',
  CALL_LINE_MANAGER: '线路管理员',
  B: '贷款经理',
  N: '客户',
  M: '现场经理',
  SYSTEM: '系统',
  T: '超管'
}
